import { atom } from 'jotai'

export const captchaInteractionRequiredAtom = atom(false)
